import React, { useCallback, useEffect, useState } from 'react';
import DialogAuthenticationLocker from '../components/_dashboard/olimpo/locker/autenticacionLocker/DialogAuthenticationLocker';
import useUserLocker from '../hooks/locker/useUserLocker';
import useQrAction from '../hooks/useQrAction';
import { useSnackbar } from 'notistack';
import { useLocation, useNavigate } from 'react-router';

function LockerGuard({ children }) {
  const [loading, setLoading] = useState(false);
  const [obtainedPath, setObtainedPath] = useState(null);
  const [regQrData, setRegQrData] = useState(null);
  const [openDialog, setOpenDialog] = useState(true);
  const { currentLockerUser, lockerId, getUserLockerData } = useUserLocker();
  const { createQrRegWithoutReference, getRegQrData } = useQrAction();
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const userLockerId = searchParams.get('user');

  console.log(currentLockerUser, 'fffffffffffffffffffff');

  const initialFunction = useCallback(async () => {
    setLoading(true);
    if (!currentLockerUser) {
      try {
        const res = await createQrRegWithoutReference(lockerId, 'AUTH-LOCKER', 'Autenticacion en locker');

        await getRegQrData(res, setRegQrData);

        const path = `${window.location.origin}/dashboard/locker_operation_user?regQrId=${res}`;
        console.log(path);
        setObtainedPath(path);

        setLoading(false);
      } catch (error) {
        enqueueSnackbar('Se ha producido un error', { variant: 'error' });

        setLoading(false);
      }
    }
  }, [createQrRegWithoutReference, currentLockerUser, enqueueSnackbar, getRegQrData, lockerId]);

  useEffect(() => {
    initialFunction();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    async function successFunc() {
      await getUserLockerData(regQrData?.userId);
    }

    if (regQrData?.status === 'USED') {
      console.log('se uso-----------------------------');
      successFunc();
    }
  }, [getUserLockerData, regQrData, regQrData?.status]);

  useEffect(() => {
    if (userLockerId) {
      getUserLockerData(userLockerId);
    }
  }, [userLockerId, getUserLockerData]);

  return (
    <>
      {!currentLockerUser && (
        <DialogAuthenticationLocker
          open={openDialog}
          onClose={setOpenDialog}
          obtainedPath={obtainedPath}
          loadingQrCode={loading}
        />
      )}

      {children}
    </>
  );
}

export default LockerGuard;
